import { render, staticRenderFns } from "./relateClientUser.vue?vue&type=template&id=4ae698ad&scoped=true&"
import script from "./relateClientUser.vue?vue&type=script&lang=js&"
export * from "./relateClientUser.vue?vue&type=script&lang=js&"
import style0 from "./relateClientUser.vue?vue&type=style&index=0&id=4ae698ad&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae698ad",
  null
  
)

export default component.exports